import { Component, inject, OnInit, signal } from '@angular/core';
import { CustomFilter, DynamicColumn, TableComponent } from '../../../../@shared/components/table-component/table-component';
import { ActivatedRoute, Router } from '@angular/router';
import { Params } from '../../../../services/utilis/add-params-service';
import { PaginatorState } from 'primeng/paginator';
import { TelemetryService } from '../../../../services/iot/telemetry-service';
import { Telemetry } from '../../../../models/telemetry';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { EngineStatus } from '../../../../models/enums';
import { enumToOptions } from '../../../../@shared/utility/enumToOptions';
import { ShowLocationDialog } from '../../../../@shared/dialogs/show-location-dialog/show-location-dialog';
@Component({
  selector: 'app-iot-data-log-list',
  imports: [TableComponent, ShowLocationDialog],
  templateUrl: './iot-data-log-list.html',
  styleUrl: './iot-data-log-list.scss'
})
export class IotDataLogList implements OnInit {

  hasPositionFilter: CustomFilter = {
    key: 'hasPosition',
    label: 'Has Position',
    type: 'select',
    options: [
      { label: 'YES', value: true },
      { label: 'NO', value: false }
    ]
  }

  dateRangeFilter: CustomFilter = {
    key: 'created',
    label: 'Date Range',
    type: 'date-range',
    options: []
  }

  params = [
    "page",
    "size",
    "search",
    'sortBy',
    'sortDirection',
    'minFuelLevel',
    'maxFuelLevel',
    'engineStatus',
    'hasPosition',
    'imei',
    'iotModel',
    'plateNo',
    'createdFrom',
    'createdTo',
  ]

  modifiedParams: Params = {
    page: "page",
    size: "size",
    search: "search",
    sortBy: "sortBy",
    sortDirection: "sortDirection",
    minFuelLevel: "minFuelLevel",
    maxFuelLevel: "maxFuelLevel",
    engineStatus: "engineStatus",
    hasCar: "hasCar",
    imei: "imei",
    iotModel: "iotModel",
    plateNo: "plateNo",
    createdFrom: "createdFrom",
    createdTo: "createdTo",
  }

  // Define columns to show in the table
  tableColumns: DynamicColumn<Telemetry>[] = [
    { header: 'ID', field: 'id', sortable: true, },
    { header: 'Device Time', field: 'timestamp', isBrowserTime: true, sortable: false },
    { header: 'Recorded At', field: 'createdAt', isDateTime: true, sortable: true },
    {
      header: 'Battery',
      field: 'powerSupplyVoltage',
      suffixText: "%",
      sortable: true,
      isFilterable: true,
      valueGetter: (row) => {
        if (!row.powerSupplyVoltage) return null;
        return Math.min((row.powerSupplyVoltage / 12) * 100, 100).toFixed(0);
      }
    },
    {
      header: 'Fuel Level',
      field: 'fuelLevel',
      sortable: true,
      suffixText: "%",
      isFilterable: true,
      filterType: 'slider',
      min: 0,
      max: 100,
      step: 1,
    },
    { header: 'Vehicle Odometer (Meters)', field: 'odometer', sortable: true },
    {
      header: 'Engine status',
      field: 'engineStatus',
      sortable: true,
      isFilterable: true,
      filterType: 'multiselect',
      filterOptions: enumToOptions(EngineStatus),
      cellClass: (value) => {
        switch (value) {
          case "ON":
            return 'text-green-500';
          case "OFF":
            return 'text-red-500';
          default:
            return 'text-gray-400';
        }
      }
    },
    { header: 'IMEI', field: 'imei', sortable: true, },
    { header: 'Vehicle speed', field: 'speed', sortable: true, },
    {
      header: 'Iot model',
      field: 'iotModel',
      sortable: true,
    },

    {
      field: 'timestamp',
      header: 'Location',
      sortable: false,
      locationCell: true,
      valueGetter: () => null,
      command: (iot) => this.openLocationDialog(iot),
    },
  ];

  activityLogList = signal<Telemetry[]>([]);
  totalRecords = signal(0);
  first = 0;
  rows = 20;

  searchControl = new FormControl('');

  selectedIOT: Telemetry
  locationDialog = false;


  private telemetryService = inject(TelemetryService)
  private router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)

  ngOnInit() {
    this.getActivityLogs()
  }

  getActivityLogs = () => {
    this.activatedRoute.queryParams.pipe(
      map((params) =>
        Object.fromEntries(
          Object.entries(params)
            .filter(([key]) => this.params.includes(key))
            .map(([key, value]) => [this.modifiedParams[key] || key, value])
        )
      ),

      distinctUntilChanged((previous, current) =>
        JSON.stringify(previous) === JSON.stringify(current)
      ),

      tap((queryParams) => {
        this.searchControl.setValue(queryParams['search'], { emitEvent: false });
        this.rows = queryParams['size'] ? +queryParams['size'] : 20;
      }),
      switchMap((queryParams) => {
        const params = {
          ...queryParams,
          sortBy: queryParams['sortBy'] ?? 'createdAt',
          sortDirection: queryParams['sortDirection'] ?? 'DESC',
        };
        return this.telemetryService.getTelemetryDataLogList(params);
      })
    )
      .subscribe((res) => {
        this.activityLogList.set(res.data.content);
        this.totalRecords.set(res.data.totalElements)
        this.first = ((res.data.currentPage + 1) * res.data.pageSize) - res.data.pageSize
      });
  }

  onPageChange = (event: PaginatorState) => {
    const queryparams = {
      page: event.page,
      size: event.rows,
    }
    this.router.navigate([], {
      queryParams: queryparams,
      queryParamsHandling: 'merge'
    })
  }

  openLocationDialog = (selectedRow: Telemetry) => {
    this.selectedIOT = selectedRow
    const url = `https://www.google.com/maps/search/?api=1&query=${selectedRow.position?.latitude ?? 0},${selectedRow.position?.longitude ?? 0}`;
    window.open(url, '_blank');
    // this.locationDialog = true
  }
}
